<template>
  <a-card :bordered="false" :bodyStyle="{ padding: '12px' }">
    <div class="table-form-wrapper">
      <a-form
        ref="searchformRef"
        name="searchform"
        :model="searchformState"
        :label-col="tableSetting.formSetting.labelCol"
        :wrapper-col="tableSetting.formSetting.wrapperCol"
      >
        <a-row>
          <a-col :span="8">
            <a-form-item label="站点编号" name="deviceCode">
              <a-input
                v-model:value="searchformState.deviceCode"
                placeholder="请输入站点编号"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="开始时间" name="rangeTime">
              <!-- <a-date-picker
                v-model:value="searchformState.fileStartTime"
                placeholder="请选择开始时间"
                show-time
              /> -->
              <a-range-picker
                v-model:value="searchformState.rangeTime"
                :show-time="{ format: 'HH:mm:ss' }"
                format="YYYY-MM-DD HH:mm:ss"
                :placeholder="['开始时间', '结束时间']"
              />
            </a-form-item>
          </a-col>
          <!-- <a-col :span="8">
            <a-form-item label="结束时间" name="fileEndTime">
              <a-date-picker
                v-model:value="searchformState.fileEndTime"
                placeholder="请选择结束时间"
                show-time
              />
            </a-form-item>
          </a-col> -->
        </a-row>
      </a-form>
      <div class="search-form-btn-wrapper">
        <a-button type="primary" @click="searchTable">
          <template #icon>
            <search-outlined />
          </template>
          查询
        </a-button>
        <a-button class="search-form-reset-btn" @click="resetTable">
          <template #icon>
            <reload-outlined />
          </template>
          重置
        </a-button>
      </div>
    </div>
    <!-- 操作按钮 -->
    <div class="table-operator-btn-wrapper">
      <a-button
        v-if="authflag.download"
        class="table-operator-export-btn"
        @click="handleDownloadFile()"
        :disabled="sKeys.length != 1"
      >
        <template #icon>
          <export-outlined />
        </template>
        下载
      </a-button>
    </div>
    <!-- 表格 -->
    <a-table
      :rowKey="'id'"
      :scroll="{ x: 1200 }"
      :columns="columns"
      :data-source="datalist"
      :loading="tableLoading"
      :row-selection="rowSelection"
      :pagination="{
        current: pageconfig.current,
        position: ['bottomLeft'],
        total: pageconfig.total,
        showTotal: (total) => `每页${pageconfig.size}条,共 ${total} 条`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '50'],
      }"
      @change="tableChange"
    >
      <template #bodyCell="{ text, column, record, index }">
        <template v-if="column.key === 'keyno'">
          <span>{{ index + 1 }}</span>
        </template>
        <template v-else-if="column.key === 'fileName'">
          <p style="word-break: break-all">
            {{ text != undefined && text != null ? text : '-' }}
          </p>
        </template>
        <!-- 文件大小 -->
        <template v-else-if="column.key === 'fileSize'">
          {{
            record.fileSize && record.fileSize > 0
              ? displaySize(record.fileSize)
              : '-'
          }}
        </template>
        <!-- 记录开始时间 -->
        <template v-else-if="column.key === 'fileStartTime'">
          {{ getTimeStr(record.fileStartTime) }}
        </template>
        <!-- 记录结束时间 -->
        <template v-else-if="column.key === 'fileEndTime'">
          {{ getTimeStr(record.fileEndTime) }}
        </template>
        <!-- 数据质量率 -->
        <template v-else-if="column.key === 'fileQuality'">
          {{
            record.fileQuality != null && record.fileQuality != undefined
              ? record.fileQuality + '%'
              : '-'
          }}
        </template>
        <!-- rinex类型 -->
        <template v-else-if="column.key === 'rinexType'">
          {{
            dic.rinexType[record.rinexType]
              ? dic.rinexType[record.rinexType]
              : '-'
          }}
        </template>
        <template v-else>
          {{ text != undefined && text != null ? text : '-' }}
        </template>
      </template>
    </a-table>
  </a-card>
</template>

<script>
import { defineComponent, reactive, ref, toRaw } from 'vue';
import dayjs from 'dayjs';
// 配置项
import defaultSetting from '@/config/defaultSettings';
// 字典项
import dic from '@/untils/Dic';
// 接口
import { getList, downloadFile } from '@/api/datamanage';
import { message } from 'ant-design-vue';

const columns = [
  { title: '序号', dataIndex: 'keyno', key: 'keyno', width: 60 },
  { title: '站点编号', dataIndex: 'deviceCode', key: 'deviceCode', width: 100 },
  // { title: '站点名称', dataIndex: 'deviceName', key: 'deviceName' },
  { title: '文件名', dataIndex: 'fileName', key: 'fileName', width: 180 },
  { title: '文件大小', dataIndex: 'fileSize', key: 'fileSize', width: 100 },
  {
    title: '记录开始时间',
    dataIndex: 'fileStartTime',
    key: 'fileStartTime',
    width: 120,
  },
  {
    title: '记录结束时间',
    dataIndex: 'fileEndTime',
    key: 'fileEndTime',
    width: 120,
  },
  {
    title: '历元预期总数',
    dataIndex: 'fileItemTotal',
    key: 'fileItemTotal',
    width: 120,
  },
  {
    title: '接收历元总数',
    dataIndex: 'fileItemReceive',
    key: 'fileItemReceive',
    width: 120,
  },
  {
    title: '数据质量率',
    dataIndex: 'fileQuality',
    key: 'fileQuality',
    width: 100,
  },
  { title: 'rinex类型', dataIndex: 'rinexType', key: 'rinexType', width: 90 },
  // {
  //   title: '操作',
  //   dataIndex: 'action',
  //   key: 'action',
  //   fixed: 'right',
  // },
];

export default defineComponent({
  name: 'DataManageList',
  setup() {
    const authflag = ref({
      download: true,
    });
    const searchformRef = ref();

    // 表格查询表单
    const searchformState = reactive({
      deviceCode: null,
      rangeTime: [],
      fileStartTime: null,
      fileEndTime: null,
    });

    // 分页数据
    const pageconfig = ref({
      size: 10,
      current: 1,
      total: 0,
    });

    // 表格数据列表
    const datalist = ref([]);
    const tableLoading = ref(false);
    let sKeys = ref([]); // 选择行的id
    let sRows = ref([]); // 选择行的row
    const confirmLoading = ref(false);

    // 多选框
    const rowSelection = ref({
      selectedRowKeys: sKeys,
      onChange: (selectedRowKeys, selectedRows) => {
        sKeys.value = selectedRowKeys;
        sRows.value = selectedRows;
      },
    });
    // 获取表格列表
    const getTableList = async () => {
      tableLoading.value = true;
      sKeys.value = [];
      // console.log(sKeys);
      // sRows.value = [];
      const params = toRaw(searchformState);
      const sendparams = {
        ...params,
        fileStartTime: params.rangeTime[0]
          ? params.rangeTime[0].format('YYYY-MM-DD HH:mm:ss')
          : undefined,
        fileEndTime: params.rangeTime[1]
          ? params.rangeTime[1].format('YYYY-MM-DD HH:mm:ss')
          : undefined,
        current: pageconfig.value.current,
        size: pageconfig.value.size,
      };
      delete sendparams.rangeTime;
      // console.log('submit,params', sendparams);
      const res = await getList(sendparams);
      tableLoading.value = false;
      // console.log(res);
      if (res.code == 0) {
        datalist.value = res.data;
        pageconfig.value.total = res.count;
      }
    };

    // 下载文件
    const handleDownloadFile = async () => {
      let filePath = sRows.value[0].filePath;
      const sendparams = {
        filePath,
      };
      const res = await downloadFile(sendparams);
      // console.log(res);
      if (res) {
        let blob = new Blob([res]);
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = sRows.value[0].fileName;
        link.click();
        window.URL.revokeObjectURL(link.href);
        message.success('下载成功');
      }
    };

    return {
      authflag,
      dic,
      tableSetting: defaultSetting.tableSetting,
      // 查询表单
      searchformRef,
      searchformState,
      // 表格
      tableLoading,
      columns,
      datalist,
      rowSelection,
      sKeys,
      sRows,
      confirmLoading,
      getTableList,
      // 分页
      pageconfig,
      handleDownloadFile,
    };
  },
  created() {
    // console.log('1111111111', this.$route.query);
    // let authdata = this.$route.query;
    // Object.keys(this.authflag).forEach((keystr) => {
    //   this.authflag[keystr] = authdata[keystr] && authdata[keystr] == 1;
    // });
    this.getTableList();
  },
  methods: {
    searchTable() {
      this.pageconfig.current = 1;
      // 查询表格
      this.getTableList();
    },
    resetTable() {
      // 重置表单
      this.pageconfig.current = 1;
      this.searchformRef.resetFields();
      this.getTableList();
    },
    tableChange(pagination) {
      this.pageconfig.current = pagination.current;
      this.pageconfig.size = pagination.pageSize;
      this.getTableList();
    },
    getTimeStr(val) {
      // console.log('val', val, typeof val);
      const str = dayjs(val).format('YYYY-MM-DD HH:mm:ss');
      return str ? str : '-';
    },
    displaySize(n) {
      let re = '';
      if (n >= 0) {
        if (n > 1024 * 1024 * 1024)
          re = String((n / 1024 / 1024 / 1024).toFixed(3)) + ' GB';
        else if (n > 1024 * 1024)
          re = String((n / 1024 / 1024).toFixed(3)) + ' MB';
        else if (n > 1024) re = String((n / 1024).toFixed(3)) + ' KB';
        else re = String(n) + ' B';
      }
      return re;
    },
  },
});
</script>
